import * as messageService from "../../services/message.service";
import * as otherIncomeService from '../../services/otherIncome.service';


const state = {
    otherIncomeAll:[],
    otherIncomeAllActive:[],
};

const getters = {
    gettOtherIncomeAll:state => (state.otherIncomeAll),
    gettOtherIncomeAllActive:state => (state.otherIncomeAllActive),
};

const actions = {
    async fetchOtherIncomeAll({ commit } ){
        try {
            const response = await otherIncomeService.all();
            commit('setOtherIncomeAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchOtherIncomeAllActive({ commit } ){
        try {
            const response = await  otherIncomeService.allActive();
            commit('setOtherIncomeAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setOtherIncomeAll:(state, res) => (
        state.otherIncomeAll =  res
    ),
    setOtherIncomeAllActive:(state, res) => (
        state.otherIncomeAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}